define(["require", "exports", "./DirectiveClipboard", "./DirectiveElDraggableDialog", "./DirectiveWave", "./DirectivesAutoFocus"], function (require, exports, DirectiveClipboard_1, DirectiveElDraggableDialog_1, DirectiveWave_1, DirectivesAutoFocus_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.directives = void 0;
    exports.directives = {
        clipboard: new DirectiveClipboard_1.DirectiveClipboard(),
        elDraggableDialog: new DirectiveElDraggableDialog_1.DirectiveElDraggableDialog(),
        wave: new DirectiveWave_1.DirectiveWave(),
        autoFocus: new DirectivesAutoFocus_1.DirectivesAutoFocus()
    };
});
//# sourceMappingURL=index.js.map